<template>
<div class="">
	<Page class="ProjectInfo" v-for="(page,i) in pages" :key='i'>
		<div class="" v-if="i===0">
			<img class="Logo" :class="{ 'Logo--right': logoPosition === 'right' }" :src="logoSrc">
			<div class="ClientAddress">
				<span class="CompanyAddress">{{ company && company.Name }} {{ company && company.Type }} &bull; {{ company && company.Address && company.Address.Street }} {{ company && company.Address && company.Address.House }} &bull; {{ company && company.Address && company.Address.PLZ }} {{ company && company.Address && company.Address.City }}</span>
				<span>{{projectInfo['Client-Name']}}</span>
				<span>{{projectInfo['Contact-Person']}}</span>
				<span v-for="(line,i) in lines(projectInfo['Street'])" :key="i">{{line}}</span>
				<span>{{projectInfo['Place']}}</span>
			</div>
			<div class="ProposalInfo">
				<span class="ProposalInfo-Number">{{projectInfo['Type']}} Nr. {{projectInfo['Project-Number']}}</span>
				<span class="ProposalInfo-Date">vom {{projectInfo['Date']}}</span>
			</div>
		</div>
		<article v-html="page.content" />
		<CompanyAddress v-if="i===0" :company="company" />
	</Page>
</div>
</template>
<script>
import Page from './Page.vue';
import CompanyAddress from './CompanyAddress.vue';

export default {
	name: 'CoverPage',
	components: {
		Page,
		CompanyAddress
	},
	props: {
		projectInfo: {
			type: Object,
			default () {
				return null
			}
		},
		company: {
			type: Object,
			default: () => null
		},
		logoPosition: {
			type: String,
			default: 'left'
		}
	},
	data() {
		return {
			pages: []
		}
	},
	created() {

	},
	watch: {
		projectInfo: function (val) {
			this.projectInfo['Project-Description'] = val['Project-Description'];
			this.splitContent();
		}
	},
	computed: {
		logoSrc() {
			if (!this.company || this.company.isMain) return require('../../assets/logo.svg');
			const name = this.company.LogoName || (this.company.InternalName ? this.company.InternalName.toLowerCase() + '.svg' : '');
			return name
				? `/static/${name}`
				: require('../../assets/logo.svg');
		}
	},
	methods: {
		lines(string){
			console.log(string);
			return string.split('\n');
		},
		splitContent() {
			this.pages = [];
			let content = this.projectInfo['Project-Description'].split('/Br');

			for (var i = 0; i < content.length; i++) {
				let obj = {};
				obj.content = content[i];
				this.pages.push(obj);
			}
		}
	},
	mounted() {
		if (this.projectInfo['Project-Description'] != undefined) {
			this.splitContent();
		}
	}
}
</script>

<style lang="scss">
article {
	hyphens: auto;
	font-size: 10pt;
	line-height: 1.5;

	.ProjectInfo & {
		padding-top: 20px;
	}

	* {
			font-family: objektiv-mk2, sans-serif!important;
		}



	h1 {
		margin: 0;
		font-size: 16pt;
		font-weight: 600;
	}

	h2 {
		margin-top: 10px;
		font-weight: 600;
		font-size: 10pt;
	}

	p, ul, ol {
		line-height: inherit;
			margin: 1.8em 0;


		}

	ul,
	ol {
		padding-left: 1.2rem;
		margin: 1.8em 0;
	}

	ul {
		list-style: disc;
	}

	h1,
	h2,
	p {
		display: block;
	}
}

article {
		padding-top: 0;
        padding-right: 2.5cm;
		line-height: 1.5;

		p {
			padding: 0;
		}

		h1 {
			font-size: 16pt;
			font-weight: 600;
			margin: 0;
		}
	}

.ProposalInfo {
	padding-top: 60px;
    padding-right: 2.5cm;

	span {
		display: block;
	}

	&-Number {
		font-size: 14pt;
	}

	&-Date {
		padding-top: 6px;
		font-size: 10pt;
	}
}

.ClientAddress {
	max-width: 8.5cm;

	.CompanyAddress {
		display: block;
		padding-bottom: 5px;
		font-size: 7pt;
	}

	span {
		display: block;
		font-size: 10pt;
	}
}

</style>



// WEBPACK FOOTER //
// CoverPage.vue?e006e0c2